export enum CGReservationStatus {
	NoReservation = 0,
	//VIP = 1,
	//ProUkazkovy = 2,
	ShowApartment = 3,
	//Upravy = 4,
	HouseManager = 5,
	//Manazer = 6,
	//Investice = 7,
	NSD = 8
}
